import { UMA_AUTH_STORAGE_KEY } from '@oneview/api/configureApi';
import { apiConfig } from '@oneview/config';
import { isAdvisor, isMidasQuoteSource, isProduction } from '@oneview/utils/branchUtils';
import { AesMidasApi } from '@orbis-systems/orbis-api-clients/aesmidas';
import { MiddlewareApi } from '@orbis-systems/orbis-api-clients/middleware';
import { OrbisApi } from '@orbis-systems/orbis-api-clients/orbis';
import { UmaApi } from '@orbis-systems/orbis-api-clients/uma';
import { InsightApi } from '@orbis-systems/orbis-api-clients/insight';
import { CacheLevel, OrbisApiMiddleware } from '@orbis-systems/orbis-api-middleware';
import { QueryClient } from '@tanstack/react-query';
import { cloneDeep } from 'lodash';

import { logoutAbortController } from './logout-abort-controller';
import { GC_TIME_10_MIN } from './constants';

const MIDAS_API_URL = `${apiConfig.umaApiUrl}/../../aes/api`;

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 0.5, // 30 seconds
            refetchOnWindowFocus: false,
            gcTime: GC_TIME_10_MIN,
        },
    },
});

export const orbis = new OrbisApi({
    debug: !isProduction(),
    baseUrl: apiConfig.apiUrl,
    authDataStorageKey: 'auth:orbis',
    storage: sessionStorage,
});

export const middleware = new MiddlewareApi({
    debug: !isProduction(),
    baseUrl: apiConfig.middlewareUrl,
    authDataStorageKey: 'auth:middleware',
    storage: sessionStorage,
});

export const uma = new UmaApi({
    debug: !isProduction(),
    baseUrl: apiConfig.umaApiUrl,
    authDataStorageKey: UMA_AUTH_STORAGE_KEY,
    storage: sessionStorage,
    firmId: String(apiConfig.umaFirmId),
    authFormSlug: apiConfig.umaAuthFormSlug,
});

export const aesmidas = new AesMidasApi({
    debug: !isProduction(),
    baseUrl: MIDAS_API_URL,
    authDataStorageKey: UMA_AUTH_STORAGE_KEY,
    storage: sessionStorage,
    onRenewTokens: () => uma.renewTokens(),
});

const insightConfig = cloneDeep(middleware.getApiClient().getConfig());
insightConfig.baseUrl += '/v1/insight';

export const insight = new InsightApi(insightConfig);

logoutAbortController.addAxiosInstance([
    middleware.getApiClient().getAxios(),
    aesmidas.getApiClient().getAxios(),
    insight.getApiClient().getAxios(),
    orbis.getApiClient().getAxios(),
    uma.getApiClient().getAxios(),
]);

export const orbisMiddleware = new OrbisApiMiddleware(
    {
        orbis,
        middleware,
        uma,
    },
    {
        cacheLevel: CacheLevel.NoCache,
        useAes: isMidasQuoteSource(),
        apiPermissions: {
            advisor: isAdvisor(),
            rtbs: true,
            iav: true,
            documents: true,
            transfers: true,
            iavProcessorToken: true,
        },
    },
);
